(() => {
  const initialize = (root) => {
    if (!root || root.dataset.atlasReviewReady === 'true') return;
    const track = root.querySelector('[data-atlas-review-track]');
    const previous = root.querySelector('[data-atlas-review-prev]');
    const next = root.querySelector('[data-atlas-review-next]');
    if (!track || !previous || !next) return;

    const distance = () => {
      const card = track.querySelector('.atlas-review-carousel__card');
      if (!card) return track.clientWidth;
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    };

    previous.addEventListener('click', () => track.scrollBy({ left: -distance(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: distance(), behavior: 'smooth' }));
    root.dataset.atlasReviewReady = 'true';
  };

  const initializeAll = (scope = document) => scope.querySelectorAll('[data-atlas-review-carousel]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
